// extracted by mini-css-extract-plugin
export var card = "_ms-0";
export var content = "_ms-2";
export var details = "_ms-3";
export var icon = "_ms-1";
export var iconBlue = "_ms-5";
export var iconBrand = "_ms-4";
export var iconGrayBlue = "_ms-6";
export var iconGreen = "_ms-7";
export var iconIndigo = "_ms-8";
export var iconOrange = "_ms-9";
export var iconPurple = "_ms-a";
export var iconRed = "_ms-b";
export var iconWarning = "_ms-c";